import { Factory } from '../interface/factory'
import { applyEntitySchema, parseEntity, sourceJson } from '../../_utils/fcdc-v2'
import { phoneSchema } from '../schema/identity.schema'

export enum PhoneStatus {
  Unverified = 'Unverified',
  PendingVerification = 'PendingVerification',
  Verified = 'Verified',
}

export class ExtraPhoneVerification {
  phoneNumber: string
  phoneVerificationCode: string

  constructor(phoneNumber: string, phoneVerificationCode: string) {
    this.phoneNumber = phoneNumber
    this.phoneVerificationCode = phoneVerificationCode
  }
}

export abstract class Phone {
  status: PhoneStatus
  number: string

  constructor(json: any, status: PhoneStatus) {
    this.status = status
    this.number = json.number
  }

  protected attachPhone(json: unknown): void {
    applyEntitySchema(this, phoneSchema, sourceJson(json), {})
  }

  static getFactory(): Factory<Phone> {
    return new (class implements Factory<Phone> {
      make(json: any): Phone {
        switch (json.status) {
          case PhoneStatus.Unverified:
            return new UnverifiedPhone(json)
          case PhoneStatus.PendingVerification:
            return new PendingPhone(json)
          case PhoneStatus.Verified:
            return new VerifiedPhone(json)
          default:
            return parseEntity(phoneSchema, json ?? {}) as unknown as Phone
        }
      }

      getTableName(): string {
        throw new Error(
          'getTableName() should never be called on a Phone. Phones are not stored in IndexDB.'
        )
      }
    })()
  }
}

export class UnverifiedPhone extends Phone {
  constructor(json: any) {
    const source = sourceJson(json) as any
    super(source, PhoneStatus.Unverified)
    this.attachPhone(source)
  }
}

export class PendingPhone extends Phone {
  code: string
  constructor(json: any) {
    const source = sourceJson(json) as any
    super(source, PhoneStatus.PendingVerification)
    this.code = source.code
    this.attachPhone(source)
  }
}

export class VerifiedPhone extends Phone {
  constructor(json: any) {
    const source = sourceJson(json) as any
    super(source, PhoneStatus.Verified)
    this.attachPhone(source)
  }
}
